module.exports = __webpack_public_path__ + "static/media/registeredDental.e31f1365.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/registeredDental.jpg
// module id = 497
// module chunks = 0